var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var PALMSController = /** @class */ (function () {
    function PALMSController() {
    }
    /*****************************************************************************************************
        * Is using route "api/PALMS/status/learner" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {StatusInfo}
    ******************************************************************************************************/
    PALMSController.StatusInfoLearner = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/status/learner", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/status/manager" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {StatusInfo}
    ******************************************************************************************************/
    PALMSController.StatusInfoManager = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/status/manager", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/glp" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {GLPEntry[]}
    ******************************************************************************************************/
    PALMSController.GLP = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/glp", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/glp/self" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {GLPEntry[]}
    ******************************************************************************************************/
    PALMSController.GLPSelf = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/glp/self", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/tmd" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {TMDEntry[]}
    ******************************************************************************************************/
    PALMSController.TMD = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/tmd", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/tmd/details" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {TMDEntry[]}
    ******************************************************************************************************/
    PALMSController.TMDDetails = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/tmd/details", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/tmd/self" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {TMDEntry[]}
    ******************************************************************************************************/
    PALMSController.TMDSelf = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/tmd/self", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/ZPT" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationEntry[]}
    ******************************************************************************************************/
    PALMSController.ZPT = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/ZPT", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/ZPT/details" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationUserEntry[]}
    ******************************************************************************************************/
    PALMSController.ZPTDetails = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/ZPT/details", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/ZPT/self" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationUserEntry[]}
    ******************************************************************************************************/
    PALMSController.ZPTself = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/ZPT/self", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/PGCS" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationEntry[]}
    ******************************************************************************************************/
    PALMSController.PGCS = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/PGCS", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/PGCS/self" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationUserEntry[]}
    ******************************************************************************************************/
    PALMSController.PGCSself = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/PGCS/self", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/PGCS/details" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationUserEntry[]}
    ******************************************************************************************************/
    PALMSController.PGCSDetails = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/PGCS/details", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/HVT" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationEntry[]}
    ******************************************************************************************************/
    PALMSController.HVT = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/HVT", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/HVT/details" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationUserEntry[]}
    ******************************************************************************************************/
    PALMSController.HVTDetails = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/HVT/details", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/futureTrainings" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {TrainingModule[]}
    ******************************************************************************************************/
    PALMSController.FutureTrainings = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/futureTrainings", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/futureTrainingsSelf" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {TrainingModule[]}
    ******************************************************************************************************/
    PALMSController.FutureTrainingsSelf = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/futureTrainingsSelf", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/MLR" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {ReadynessState[]}
    ******************************************************************************************************/
    PALMSController.MLR = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/MLR", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/MLR/details" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {MLREntry[]}
    ******************************************************************************************************/
    PALMSController.MLRdetails = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/MLR/details", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/certification" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {CertificationEntry[]}
    ******************************************************************************************************/
    PALMSController.Certification = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/certification", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/certification/self" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {CertificationEntry[]}
    ******************************************************************************************************/
    PALMSController.CertificationSelf = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/certification/self", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/teamJobRoles/{teamManagerId}" and http method "GET" to call the back-end.
    
        * @param {string} teamManagerId
        * @returns {string[]}
    ******************************************************************************************************/
    PALMSController.TeamJobRoles = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/teamJobRoles/{teamManagerId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/teamMembers" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {PALMSUser[]}
    ******************************************************************************************************/
    PALMSController.TeamMembers = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/teamMembers", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/markets" and http method "GET" to call the back-end.
    
        * @returns {string[]}
    ******************************************************************************************************/
    PALMSController.Markets = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/markets", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/jobroles/{onlyManager}/{market?}" and http method "GET" to call the back-end.
    
        * @param {boolean} onlyManager
        * @param {string} market
        * @returns {string[]}
    ******************************************************************************************************/
    PALMSController.JobRoles = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/jobroles/{onlyManager}/{market?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/PALMS/users/{onlyManager}/{jobrole?}" and http method "GET" to call the back-end.
    
        * @param {boolean} onlyManager
        * @param {string} jobrole
        * @returns {PALMSUser[]}
    ******************************************************************************************************/
    PALMSController.Users = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/users/{onlyManager}/{jobrole?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return PALMSController;
}());
export { PALMSController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PALMSController.js.map